import { Instance, types } from 'mobx-state-tree';
import { HouseChatAttachmentTabType } from '../types';
import { ChatAttachmentItemDTO } from 'http-requests/house-chats';
import { RequestStateModel } from '../../general-models';

export const ChatAttachmentItemModel = types.model('ChatAttachmentItemModel', {
  id: types.string,
  type: types.string,
  max_message_id: types.string,
  filename: types.optional(types.maybeNull(types.string), null),
  size: types.optional(types.maybeNull(types.number), null),
});

const toItemSnapshot = (item: ChatAttachmentItemDTO) => ({
  id: item.id,
  type: item.type,
  max_message_id: item.max_message_id,
  filename: item.filename,
  size: item.size,
});

export const ChatAttachmentsTabModel = types
  .model('ChatAttachmentsTabModel', {
    items: types.optional(types.array(ChatAttachmentItemModel), []),
    total: types.optional(types.number, 0),
    requestState: types.optional(RequestStateModel, {}),
    loadMoreState: types.optional(RequestStateModel, {}),
  })
  .views((self) => ({
    get hasMore() {
      return self.items.length < self.total;
    },
  }))
  .actions((self) => ({
    setItems(items: ChatAttachmentItemDTO[], total: number) {
      self.items.replace(items.map(toItemSnapshot));
      self.total = total;
    },
    appendItems(items: ChatAttachmentItemDTO[], total: number) {
      const known = new Set(self.items.map((item) => item.id));

      self.items.push(
        ...items.filter((item) => !known.has(item.id)).map(toItemSnapshot)
      );
      self.total = total;
    },
  }));

export type TChatAttachmentItem = Instance<typeof ChatAttachmentItemModel>;
export type TChatAttachmentsTab = Instance<typeof ChatAttachmentsTabModel>;

export const attachmentsTabKey = (
  chatId: number,
  type: HouseChatAttachmentTabType
): string => `${chatId}:${type}`;
